import type Image from "../models/Image";

const STRAPI_BASE =
  import.meta.env.VITE_CMS_URL ||
  "https://mohren-strapi-new-vs7i8.ondigitalocean.app";

function absolutize(url: string | undefined): string | undefined {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  return `${STRAPI_BASE.replace(/\/$/, "")}${url.startsWith("/") ? "" : "/"}${url}`;
}

export interface ResolvedImage {
  src: string;
}

export function resolveStrapiImage(image: Image | null | undefined): ResolvedImage | null {
  if (!image) return null;
  const url =
    image.formats?.large?.url ||
    image.formats?.medium?.url ||
    image.formats?.small?.url ||
    image.url;
  const abs = absolutize(url);
  if (!abs) return null;
  return { src: abs };
}
